import React, { Component } from 'react';
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {getPropertyDefinitions, privateCoreLogout} from "../../../redux/actions";

class PrivateSummary extends Component {
    constructor(props) {
        super(props);
        this.customerId = props.match.params.id;
        this.loadPropertyDefinitions();
    }


    loadPropertyDefinitions() {
        this.props.dispatch(getPropertyDefinitions({id: this.customerId}));
    }

    back() {
        this.props.dispatch(privateCoreLogout());
        this.props.history.push("/customers"); // TODO: once react-router is moved to the redux state, this might as well become part of the privateCoreLogout middleware method (after calling next)
    }

    render() {
        return this.props.customer ?
            <div>
                <h3>{this.props.customer.name}</h3>
                <a onClick={e => this.back()}> Back to customers</a>
            </div>
        : null;
    }
}

const mapStateToProps = state => {
    return { propertyDefinitions: state.propertyDefinitions, customer: state.currentCustomer };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateSummary));


// WEBPACK FOOTER //
// ./src/components/customer/private/PrivateSummary.js